<form [formGroup]="form" NfFormValidation (validSubmit)="onSubmit()">
  <div class="modal-header" hsDraggable="modal-dialog">
    <h4 class="modal-title">
      {{ modalTitle }}
    </h4>
    <button
      nf-icon-button="cancel"
      icon="close"
      class="btn-bare"
      ngbTooltip="Close"
      (click)="onCancel()"
    ></button>
  </div>
  <div class="modal-body" hsDraggable="modal-dialog">
    <ng-container [formGroup]="form" *ngIf="form">
      <nf-form-control
        label="Note"
        for="noteFormControl"
        [customErrorMessages]="validationMessages.notesValidationMessages"
      >
        <textarea
          ngbAutofocus
          class="form-control"
          id="noteFormControl"
          formControlName="note"
          data-cy="note"
          rows="8"
        ></textarea>
      </nf-form-control>
    </ng-container>
  </div>
  <div class="modal-footer" hsDraggable="modal-dialog">
    <button nf-button="cancel" (click)="onCancel()"></button>
    <button nf-button="submit" [disabled]="form.invalid">Save</button>
  </div>
</form>
